import { useDatadog } from './useDatadog';

interface AppMonitorAgent {
  captureException: (error: Error, context?: Record<string, unknown>) => void;
  setUser: (user: GetProviderByIdResponse) => void;
}

const useAppMonitor = (): AppMonitorAgent => {
  const datadogAgent = useDatadog();

  const captureException = (
    error: Error,
    context?: Record<string, unknown>,
  ) => {
    datadogAgent.logError(error, context);
  };

  const setUser = (user: GetProviderByIdResponse) => {
    datadogAgent.setCurrentUserId(user.userId);
  };

  return { captureException, setUser };
};

export default useAppMonitor;
